import { link } from 'fs';
/* eslint-disable indent */
import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { PedidoLista } from '../models/pedido-lista';
import { Filtro } from '../models/filtro';
import { MatPaginator, PageEvent, MatDialog } from '@angular/material';
import { PedidoService } from '../services/pedido.service';
import { UtilitarioService } from '../services/utilitario.service';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import swal from 'sweetalert2';
import {
  StatusDoPedido,
  PerfilDoUsuario,
  TipoDeLogAcesso,
  AnaliseDescontoStatus,
  OrigemFiltroPedido,
  OrdenacaoPadraoOrcPed,
  EtapaDoPedido
} from '../models/enum';
import { FiltroPedido } from '../models/filtro-pedido';
import { FiltroPedidoComponent } from './filtro-pedido/filtro-pedido.component';
import { GlobalService } from '../services/global.service';
import { stringify } from 'querystring';
import { Pedido } from '../models/pedido';
import { ResumoModalComponent } from '../modals/resumo-modal/resumo-modal.component';
import { EstoqueModalComponent } from './../modals/estoque-modal/estoque-modal.component';
import { NotaFiscalService } from './../services/nota-fiscal.service';
import { DigitaCampoModalComponent } from '../modals/digita-campo-modal/digita-campo-modal.component';
import { ProdutoService } from '../services/produto.service';
import { Cliente } from '../models/cliente';
import { ObservacoesModalComponent } from '../modals/observacoes-modal/observacoes-modal.component';
import { RelatorioService } from '../services/relatorio.service';
import { ObsModalComponent } from '../modals/obs-modal/obs-modal.component';
import { Produto, ProdutoDesconto } from '../models/produto';
import { PedidoAnexoComponent } from './pedido-anexo/pedido-anexo.component';
import { NotaFiscalPedidoModalComponent } from '../modals/nota-fiscal-pedido-modal/nota-fiscal-pedido-modal.component';
import { SelecionarStatusOrcamentoModalComponent } from '../modals/selecionar-status-orcamento-modal/selecionar-status-orcamento-modal.component';
import { VendaEntrega } from '../models/venda-entrega';
import { PremissasService } from '../services/premissas.service';
import { CupomDescontoModalComponent } from '../modals/cupom-desconto-modal/cupom-desconto-modal.component';
import { SelecionarOcorrenciaModalComponent } from '../modals/selecionar-ocorrencia-modal/selecionar-ocorrencia-modal.component';
import { LogAcesso } from '../models/log-acesso';
import { LogAcessoService } from '../services/log-acesso.service';
import { OrcStatusService } from '../services/orc-status.service';
import { SelecionarArquivoBoletoPedidoModalComponent } from '../modals/selecionar-arquivo-boleto-pedido-modal/selecionar-arquivo-boleto-pedido-modal.component';
import { FuncionarioService } from '../services/funcionario.service';
import { UsuarioIntegrador } from '../models/usuario-integrador';
import { UsuarioIntegradorService } from '../services/usuario-integrador.service';
import { ClienteService } from '../services/cliente.service';
import { AnotacaoStatusModalComponent } from '../modals/anotacao-status-modal/anotacao-status-modal.component';
import { SelecionarEtapaPedidoModalComponent } from '../modals/selecionar-etapa-pedido-modal/selecionar-etapa-pedido-modal.component';
import { UsuarioLogado } from '../models/usuario-logado';
import { FormaDePagamento } from '../models/forma-de-pagamento';
import { FormaDePagamentoService } from '../services/forma-de-pagamento.service';
import { PagamentoOctopusComponent } from '../modals/pagamento-octopus/pagamento-octopus.component';
import { PaginatorService } from '../services/paginator.service';
import { PremissasSistema } from '../models/premissas-sistema';
import { TransferenciaItemsVendedorModalComponent } from '../modals/transferencia-items-vendedor-modal/transferencia-items-vendedor-modal.component';
import { OctopusService } from '../services/octopusService';
import { ProdutoBloqueado } from '../models/produto-bloqueado';
import { EstoqueProdutoModalComponent } from '../modals/estoque-produto-modal/estoque-produto-modal.component';
import { PrecificacaoUF } from '../models/precificacao-uf';
import { PrecificacaoUFService } from '../services/precificacao-uf.service';
import { AnaliseDescontoSolicitacaoModalComponent } from '../modals/analise-desconto-solicitacao-modal/analise-desconto-solicitacao-modal.component';
import { Financiamento } from '../models/financiamento/financiamento';
import { FinanciamentoService } from '../services/financiamento.services';
import { FinSimulacaoService } from '../services/fin-simulacao.service';
import { RastreioPedidoModalComponent } from '../modals/rastreio-pedido-modal/rastreio-pedido-modal.component';
import { Subscription } from 'rxjs';
import { GridfyFilter } from '../core/models/gridfy-filter';
import { QueryFilterService } from '../core/services/query-filter-service';
import { NovaSimulacaoModalComponent } from '../modals/nova-simulacao-modal/nova-simulacao-modal.component';
import { GiFinSimulacaoModel } from '../dominio/gi-fin-simulacao-model';
import { SimulacaoService } from '../financiamento/services/simulacao-service';
import { StringNullableChain } from 'lodash';

declare const $: any;

@Component({
  selector: 'app-pedido',
  templateUrl: './pedido.component.html',
  styleUrls: ['./pedido.component.scss']
})
export class PedidoComponent implements OnInit, OnDestroy {
  pKitProntoDesconto = false;
  // variáveis
  // pedidos: Pedido[] = [];
  pedidosFiltrados: PedidoLista[] = [];
  carregando = true;
  campoOrdenacao = 'idvenda';
  ordenarDesc = true;
  editavel = true;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [10, 30, 50];
  itensPorPagina = 10;
  clienteFaturamento: Cliente;
  calcularFrete = false;
  calcularDesconto = false;
  bloqClonar = false;
  fidelidadeGoSolar = false;

  bloquearTipoFreteVendaDireta = false;

  comprovante;
  usuariosDoIntegrador: UsuarioIntegrador[] = [];
  idUsuarioIntegrador;

  texto = 'Pedido';

  StatusDoPedido = StatusDoPedido;
  PerfilDoUsuario = PerfilDoUsuario;

  pVendaProgramada = false;

  confirmar = false;

  perfil: PerfilDoUsuario;

  filtroPedido: FiltroPedido = {
    dtFim: undefined,
    dtInicio: undefined,
    funcionario: undefined,
    idCupom: '',
    nomeCliente: '',
    status: undefined,
    etapas: [],
    integrador: undefined,
    orcStatus: undefined,
    referencia: undefined,
    idFornecedor: undefined,
    codErp: '',
    pesquisaPorTimes: false
  };

  filtroExterno: any;

  integradorPodeAnexar = false;

  integradorPodeAbrirOcorrencia = false;

  integrador = false;
  tipo = 0;
  pedido: Pedido;
  itens: any[] = [];
  enderecoDeEntrega: VendaEntrega = new VendaEntrega();
  verCustos = undefined;
  administrador;

  podeConfirmarPedido = false;
  podeVerTodosPedidos = false;

  boletoFotus = false;

  pCentroDistribuicao = false;
  pMultiFornecedor = false;

  respostas = [];

  modulosAtivos: Number[] = [];

  usuario: UsuarioLogado;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  buscouPedidos = false;
  buscouTotalPag = false;
  podeVerEstoque = false;

  formasDePagamentosOctopus: FormaDePagamento[] = [];
  formasDePagamentosMercadoPago: FormaDePagamento[] = [];

  bloquearSistema: boolean = false;
  premissasSistema = new PremissasSistema();

  produtosBloqueados = [];

  precificacoesUF: PrecificacaoUF[] = [];

  descAcresPrecificacaoUF: PrecificacaoUF;

  financiamentoConfig: Financiamento = new Financiamento();

  podeFinanciar = false;

  private subscriptionPedidos$: Subscription;
  private subscriptionTotais$: Subscription;
  private subscriptionsPedidoRastreio$: Subscription[] = [];

  constructor(
    private pedidoService: PedidoService,
    public utilitarioService: UtilitarioService,
    public dialog: MatDialog,
    public premissasService: PremissasService,
    private router: Router,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private orcStatusService: OrcStatusService,
    private globalService: GlobalService,
    private notaFiscalService: NotaFiscalService,
    private route: ActivatedRoute,
    private produtoService: ProdutoService,
    private relatorioService: RelatorioService,
    private logAcessoService: LogAcessoService,
    private funcionarioService: FuncionarioService,
    private usuarioDoIntegradorService: UsuarioIntegradorService,
    private clienteService: ClienteService,
    private hopperOctopusGiService: OctopusService,
    private formaDePagamentoService: FormaDePagamentoService,
    private paginatorService: PaginatorService,
    private precificacaoUFService: PrecificacaoUFService,
    private financiamentoService: FinanciamentoService,
    private finSimulacaoService: FinSimulacaoService,
    private queryFilterService: QueryFilterService,
    private simulacaoService: SimulacaoService
  ) {
    if (this.router.getCurrentNavigation().extras.state && this.router.getCurrentNavigation().extras.state.filtro) {
      this.filtroExterno = this.router.getCurrentNavigation().extras.state.filtro;
    }
  }

  async ngOnInit() {
    const userId = await (await this.globalService.consultaUsuario()).id;

    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    await this.buscarFinanciamentoConfig();
    await this.buscarModulosAtivos();
    await this.buscarBloquearTipoFreteVendaDireta();

    await this.buscarPremissasSistema();
    this.buscarIntegradorAnexar();
    this.buscarPremissaBoletoFotus();
    this.buscarKitProntoFreteDesconto();
    this.buscarBloqClonar();
    this.buscarPremissaCentroDeDistribuicao();
    this.buscarPremissaVendaProgramada();
    this.buscarPremissaMultiFornecedor();
    this.buscarKitProntoDesconto();
    this.consultaPodeVerEstoque(userId);
    this.buscarIntegradorPodeAbrirOcorrencia();
    this.buscarFormasDePagamento();

    this.usuario = await this.globalService.consultaUsuario();

    this.integrador = await this.globalService.integrador();
    this.administrador = await this.globalService.administrador();
    this.verCustos = this.usuario.verCustos;
    this.perfil = await this.globalService.perfil();

    this.podeFinanciar =
      !this.integrador || (this.integrador && (await this.verificarSeIntegradorPodeSimular(this.usuario.id)));

    this.podeConfirmarPedido = this.usuario.podeConfirmarPedido;

    if (this.integrador) {
      this.podeVerTodosPedidos = this.usuario.verTodosPedidos;
      this.idUsuarioIntegrador = this.usuario.idUsuarioIntegrador;
    }

    this.route.data.subscribe((data: Data) => {
      this.tipo = data['tipo'];
      this.texto = this.tipo === 0 ? 'Orçamento' : 'Pedido';
    });

    if (!this.premissasSistema.habilitaOrcamento && this.tipo === 0) {
      this.notificacaoService.erro('Acesso restrito!');
      this.router.navigate(['/']);
    }

    if (localStorage.getItem('filtroPedido') !== null) {
      this.filtroPedido = JSON.parse(localStorage.getItem('filtroPedido'));
      if (this.filtroPedido.funcionario === null || this.filtroPedido.funcionario === undefined) {
        if (this.administrador) {
          this.filtroPedido.funcionario = 0;
        } else if (!this.integrador) {
          this.filtroPedido.funcionario = -1;
        }
      }
    } else {
      if (this.perfil === PerfilDoUsuario.Vendedor) {
        this.filtroPedido.funcionario = -1; // this.globalService.consultaUsuario().id;
      }
    }

    if (this.filtroExterno) {
      this.filtroPedido.status = StatusDoPedido.Ativo;
      this.filtroPedido.dtInicio = this.filtroExterno.dataInicio;
      this.filtroPedido.dtFim = this.filtroExterno.dataFim;
      this.filtroPedido.integrador = this.filtroExterno.integrador;
      this.filtroPedido.funcionario = this.filtroExterno.vendedor;
      if (this.filtroExterno.etapa) {
        this.filtroPedido.etapas = [this.filtroExterno.etapa];
      } else {
        this.filtroPedido.etapas = [];
      }
    }

    this.buscarPremissasBloqueioSistema();
    this.buscarPedidos();
    this.buscarTotal();
  }

  destroySubscriptionPedidos() {
    if (this.subscriptionPedidos$ !== null && this.subscriptionPedidos$ !== undefined) {
      this.subscriptionPedidos$.unsubscribe();
      this.subscriptionPedidos$ = undefined;
    }
  }

  destroySubscriptionTotais() {
    if (this.subscriptionTotais$ !== null && this.subscriptionTotais$ !== undefined) {
      this.subscriptionTotais$.unsubscribe();
      this.subscriptionTotais$ = undefined;
    }
  }

  destroySubscriptionPedidoRastreio() {
    if (this.subscriptionsPedidoRastreio$ !== null && this.subscriptionsPedidoRastreio$ !== undefined) {
      this.subscriptionsPedidoRastreio$.forEach((s) => {
        if (s !== null && s !== undefined) {
          s.unsubscribe();
          s = undefined;
        }
      });

      this.subscriptionsPedidoRastreio$ = [];
    }
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
      if (this.premissasSistema.usarPrecificacaoPorUF) {
        this.buscarPrecificacoesUF();
      }

      if (this.premissasSistema.ordenacaoPadraoOrcPed === OrdenacaoPadraoOrcPed.DataHora) {
        this.campoOrdenacao = 'data';
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  buscarPremissasBloqueioSistema() {
    this.carregandoService.mostra('buscarBloqSist');
    this.premissasService.consultarBloqSistManuProd().subscribe(
      (data) => {
        this.bloquearSistema = data;
        this.carregandoService.esconde('buscarBloqSist');
      },
      (erro) => {
        this.carregandoService.esconde('buscarBloqSist');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarFormasDePagamento() {
    this.carregandoService.mostra('buscaFormas');
    this.formaDePagamentoService.consultar().subscribe(
      (data) => {
        this.formasDePagamentosOctopus = data.filter(
          (forma) => forma.actionOctopusId !== null && forma.gatewayOctopusId !== null
        );
        this.formasDePagamentosMercadoPago = data.filter((forma) => forma.tipo === 1);
        this.carregandoService.esconde('buscaFormas');
      },
      (erro) => {
        this.carregandoService.esconde('buscaFormas');
        this.notificacaoService.erro('Não foi possível buscar as formas de pagamento.');
      }
    );
  }

  consultaPodeVerEstoque(id: number) {
    this.carregandoService.mostra('podeVerEstoque');
    this.funcionarioService.consultaPodeVerEstoque(id).subscribe(
      (resp) => {
        this.podeVerEstoque = resp;
        this.carregandoService.esconde('podeVerEstoque');
      },
      (erro) => {
        this.carregandoService.esconde('podeVerEstoque');
        console.error(erro);
        this.notificacaoService.erro('Não foi possível verificar se o usuário pode ver o estoque.');
      }
    );
  }

  possuiModulo(modulo: Number) {
    return this.modulosAtivos.some((p) => p === modulo);
  }

  async buscarModulosAtivos() {
    try {
      this.modulosAtivos = await this.premissasService.consultarModulosAtivos().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    }
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize
      });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.paginator.firstPage();
    this.paginacao.paginaAtual = 1;
    this.paginacao.total = 0;
    this.buscarPedidos();
  }

  buscarIntegradorPodeAbrirOcorrencia() {
    this.carregandoService.mostra('buscarIntegradorPodeAbrirOcorrencia');
    this.premissasService.consultarIntegradorPodeAbrirOcorrencia().subscribe(
      (f) => {
        this.integradorPodeAbrirOcorrencia = f.valor;
        this.carregandoService.esconde('buscarIntegradorPodeAbrirOcorrencia');
      },
      (erro) => {
        this.notificacaoService.erro(erro);
        this.carregandoService.esconde('buscarIntegradorPodeAbrirOcorrencia');
      }
    );
  }

  buscarPremissaCentroDeDistribuicao() {
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      (f) => {
        this.pCentroDistribuicao = f.valor;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaVendaProgramada() {
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      (f) => {
        this.pVendaProgramada = f.valor;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaMultiFornecedor() {
    this.premissasService.consultarMultiFornecedores().subscribe(
      (f) => {
        this.pMultiFornecedor = f.valor;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPremissaBoletoFotus() {
    this.premissasService.consultarBoletoFotus().subscribe(
      (dados) => {
        this.boletoFotus = dados.valor;
      },
      (err) => {
        this.notificacaoService.erro(err);
      }
    );
  }

  async buscarCliente(id, notificaErro: boolean = true) {
    const gi: boolean | null = notificaErro ? true : null;

    try {
      this.carregandoService.mostra('buscarCliente');
      return await this.clienteService.consultarPorIdCliente(id, gi).toPromise();
    } catch (erro) {
      if (notificaErro) {
        this.notificacaoService.erro(erro);
      }
    } finally {
      this.carregandoService.esconde('buscarCliente');
    }
  }

  abrirBoleto(pedido: Pedido) {
    this.carregandoService.mostra('abrirBoleto');

    if (this.boletoFotus) {
      this.pedidoService.buscarCryptCupomFotus(pedido.idCupom).subscribe(
        ({ result }) => {
          this.carregandoService.esconde('abrirBoleto');
          this.notificacaoService.sucesso('Boleto aberto em outra aba com sucesso!!!');
          window.open('https://cliente.fotus.com.br/boletos?text=' + result, '_blank');
        },
        (err) => {
          this.carregandoService.esconde('abrirBoleto');
          this.notificacaoService.erro(err);
        }
      );
    } else {
      this.pedidoService.buscarListaArqBoleto(pedido.idCupom).subscribe(
        ({ fileNames }) => {
          this.carregandoService.esconde('abrirBoleto');

          if (fileNames.length > 0) {
            fileNames = fileNames.filter((p) => p !== '');
          }

          if (fileNames.length > 0) {
            const largura = Number($('body').width());

            const dialogRef = this.dialog.open(SelecionarArquivoBoletoPedidoModalComponent, {
              width: largura > 500 ? '550px' : $('body').width().toString() + 'px',
              data: { fileNames: fileNames },
              panelClass: 'modal-card'
            });

            dialogRef.afterClosed().subscribe((fileName) => {
              if (fileName) {
                this.abrirBoletoSelecionado(pedido.idCupom, fileName);
              }
            });
          } else {
            this.notificacaoService.erro('Não existem boletos lançados para este pedido.');
          }
        },
        (err) => {
          this.carregandoService.esconde('abrirBoleto');
          this.notificacaoService.erro(err);
        }
      );
    }
  }

  abrirBoletoSelecionado(idCupom, fileName) {
    this.carregandoService.mostra('baixarBoletoSelecionado');
    this.pedidoService.baixarBoletoPedido(idCupom, fileName).subscribe(
      (arq) => {
        this.utilitarioService.openBlobModal(arq, fileName);
        this.carregandoService.esconde('baixarBoletoSelecionado');
      },
      (err) => {
        this.carregandoService.esconde('baixarBoletoSelecionado');
        this.notificacaoService.erro(err);
      }
    );
  }

  podeExibirRastreio() {
    this.pedidosFiltrados.forEach((p) => {
      this.subscriptionsPedidoRastreio$.push(
        this.pedidoService.existeRastreio(p.idCupom).subscribe((data) => {
          p.podeVerRastreio = data.podeVerRastreio;
        })
      );
    });
  }

  abrirModalRastreio(idCupom: string, codErp: string) {
    if (this.premissasSistema.tipoRastreamento === 1) {
      const dialogRef = this.dialog.open(RastreioPedidoModalComponent, {
        width: '1200px',
        data: {
          idCupom: idCupom
        },
        disableClose: true,
        panelClass: 'modal-card'
      });

      dialogRef.afterClosed().subscribe((result) => {});
    } else if (this.premissasSistema.tipoRastreamento === 2) {
      this.buscarLinkRastreio(idCupom, codErp);
    }
  }

  buscarLinkRastreio(idCupom: string, codErp: string) {
    this.carregandoService.mostra('buscaLinkRastreio');
    this.pedidoService.buscarLinkRastreio(idCupom, codErp).subscribe(
      (data) => {
        const link = data.link;
        this.carregandoService.esconde('buscaLinkRastreio');

        window.open(link, '_blank');
      },
      (erro) => {
        this.carregandoService.esconde('buscaLinkRastreio');
        console.error('Erro: ', erro.error);
      }
    );
  }

  buscarPedidos() {
    this.buscouPedidos = false;

    localStorage.setItem('filtroPedido', JSON.stringify(this.filtroPedido));

    let etapas = undefined;
    if (this.tipo === 0) {
      etapas = '-1';
    } else if (this.filtroPedido.etapas && this.filtroPedido.etapas.length > 0) {
      etapas = this.filtroPedido.etapas.join(',');
    }

    this.destroySubscriptionPedidos();
    this.destroySubscriptionPedidoRastreio();

    this.pedidosFiltrados = [];

    this.subscriptionPedidos$ = this.pedidoService
      .consultarComPaginacao(
        this.paginacao.paginaAtual,
        this.itensPorPagina,
        this.campoOrdenacao,
        this.ordenarDesc ? 'desc' : 'asc',
        this.filtroPedido.dtInicio && typeof this.filtroPedido.dtInicio !== 'string'
          ? this.filtroPedido.dtInicio.toISOString()
          : this.filtroPedido.dtInicio,
        this.filtroPedido.dtFim && typeof this.filtroPedido.dtFim !== 'string'
          ? this.filtroPedido.dtFim.toISOString()
          : this.filtroPedido.dtFim,
        this.filtroPedido.nomeCliente,
        this.filtroPedido.idCupom,
        this.filtroPedido.status,
        this.filtroPedido.funcionario === 0
          ? undefined
          : this.filtroPedido.funcionario === -1
            ? this.usuario.id
            : this.filtroPedido.funcionario,
        etapas,
        false,
        false,
        this.filtroPedido.integrador ? this.filtroPedido.integrador : null,
        this.filtroPedido.orcStatus,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.integrador && this.podeVerTodosPedidos ? this.filtroPedido.idUsuarioIntegrador : this.idUsuarioIntegrador,
        this.filtroPedido.referencia,
        this.filtroPedido.cd,
        this.filtroPedido.codErp,
        null,
        null,
        false,
        false,
        true,
        false,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.filtroPedido.possuiRespostaAnaliseDesconto,
        this.filtroPedido.pesquisaPorTimes
      )
      .subscribe(
        async (dados) => {
          this.pedidosFiltrados = dados.itens.map((p) => {
            return { ...p, podeVerRastreio: false };
          });
          this.buscouPedidos = true;

          this.podeExibirRastreio();
        },
        (erro) => {
          this.buscouPedidos = true;
          this.notificacaoService.erro(erro);
        }
      );
  }

  buscarTotal() {
    localStorage.setItem('filtroPedido', JSON.stringify(this.filtroPedido));
    this.buscouTotalPag = false;
    let etapas = undefined;

    if (this.tipo === 0) {
      etapas = '-1';
    } else if (this.filtroPedido.etapas && this.filtroPedido.etapas.length > 0) {
      etapas = this.filtroPedido.etapas.join(',');
    }

    // somente valores
    this.destroySubscriptionTotais();

    this.subscriptionTotais$ = this.pedidoService
      .consultarTotalPaginacao(
        this.filtroPedido.dtInicio && typeof this.filtroPedido.dtInicio !== 'string'
          ? this.filtroPedido.dtInicio.toISOString()
          : this.filtroPedido.dtInicio,
        this.filtroPedido.dtFim && typeof this.filtroPedido.dtFim !== 'string'
          ? this.filtroPedido.dtFim.toISOString()
          : this.filtroPedido.dtFim,
        this.filtroPedido.nomeCliente,
        this.filtroPedido.idCupom,
        this.filtroPedido.status,
        this.filtroPedido.funcionario === 0
          ? undefined
          : this.filtroPedido.funcionario === -1
            ? this.usuario.id
            : this.filtroPedido.funcionario,
        etapas,
        false,
        false,
        this.filtroPedido.integrador ? this.filtroPedido.integrador : null,
        this.filtroPedido.orcStatus,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.integrador && this.podeVerTodosPedidos ? this.filtroPedido.idUsuarioIntegrador : this.idUsuarioIntegrador,
        this.filtroPedido.referencia,
        this.filtroPedido.cd,
        this.filtroPedido.codErp,
        null,
        null,
        false,
        false,
        true,
        false,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        this.filtroPedido.possuiRespostaAnaliseDesconto,
        this.filtroPedido.pesquisaPorTimes
      )
      .subscribe(
        (dados) => {
          this.paginacao.total = dados.total;
          this.buscouTotalPag = true;
        },
        (erro) => {
          this.notificacaoService.erro(erro);
          this.buscouTotalPag = true;
        }
      );
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize) this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarPedidos();
  }

  novoPedido() {
    this.router.navigate(['/pedidos/novo']);
  }

  editarPedido(pedido: PedidoLista) {
    this.gerarLogAcesso(pedido.idCupom, TipoDeLogAcesso.EditarPedido);
    this.router.navigate(['/pedidos/editar', pedido.idCupom]);
  }

  editarOrcamento(pedido: PedidoLista) {
    this.gerarLogAcesso(pedido.idCupom, TipoDeLogAcesso.EditarOrcamento);
    this.router.navigate(['/orcamentos/editar', pedido.idCupom]);
  }

  gerarLogAcesso(idCupom: string, tipo: TipoDeLogAcesso) {
    const logAcesso: LogAcesso = {
      tipo,
      idCupom
    };

    this.logAcessoService.Salvar(logAcesso).subscribe(() => {});
  }

  duplicarPedido(pedido: PedidoLista, tipo?) {
    if (pedido.origemGI === 2 && this.bloquearTipoFreteVendaDireta) {
      return;
    } else {
      this.gerarLogAcesso(
        pedido.idCupom,
        this.tipo === 0 ? TipoDeLogAcesso.ClonarOrcamento : TipoDeLogAcesso.ClonarPedido
      );

      this.pedidoService.consultarProdutosBloqueados(pedido.idCupom).subscribe(
        () => {
          if (tipo === 0) {
            this.router.navigate(['/orcamentos/novo'], {
              state: { idCupom: pedido.idCupom, tipo: 0, duplicando: true }
            });
          } else {
            this.router.navigate(['/pedidos/novo'], {
              state: { idCupom: pedido.idCupom, tipo: 1, duplicando: true }
            });
          }
        },
        (err) => this.notificacaoService.erro(err)
      );
    }
  }

  acompanharPedido(pedido: PedidoLista) {
    this.router.navigate(['/pedidos/historico'], { state: { idCupom: pedido.idCupom } });
  }

  abrirModalOcorrencias(pedido: PedidoLista) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(SelecionarOcorrenciaModalComponent, {
      width: largura > 930 ? '900px' : $('body').width().toString() + 'px',
      data: { idCupom: pedido.idCupom, tipo: this.tipo },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  pesquisarPedido() {
    const filtroTemp = Object.assign({}, this.filtroPedido);

    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(FiltroPedidoComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: {
        filtro: filtroTemp,
        tipo: this.tipo,
        origem: this.tipo == 0 ? OrigemFiltroPedido.Orcamento : OrigemFiltroPedido.Pedido
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: FiltroPedido) => {
      if (result) {
        this.filtroPedido = result;
        this.paginator.firstPage();
        this.paginacao.paginaAtual = 1;
        this.paginacao.total = 0;

        this.buscarPedidos();
        this.buscarTotal();
      }
    });
  }

  pesquisarEstoque() {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(EstoqueModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {},
      panelClass: 'modal-card'
    });
  }

  ngOnDestroy(): void {
    this.destroySubscriptionPedidos();
    this.destroySubscriptionTotais();
    this.destroySubscriptionPedidoRastreio();
  }

  async confirmarPedido(pedido: PedidoLista) {
    if (
      this.premissasSistema.naoValidarPedido &&
      this.premissasSistema.origensParaNaoValidarPedido.some((p) => p === pedido.origemGI) &&
      pedido.ordemEtapa === EtapaDoPedido.Editando
    ) {
      await this.gerarPedido(
        pedido.idCupom,
        pedido.ibge,
        pedido.nomeResponsavel,
        pedido.telefoneResponsavel,
        pedido.potencia,
        pedido.ufEntrega,
        pedido.vendedor
      );
      return;
    }

    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(ResumoModalComponent, {
      width: $('body').width().toString() + 'px',
      data: {
        idCupom: pedido.idCupom,
        exibirConcordarTermos: true,
        bloquearTipoFreteVendaDireta: this.bloquearTipoFreteVendaDireta && pedido.origemGI === 2
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.buscarPedidos();
      }
    });
  }

  // 0 - faturamento | 1- fiscal
  imprimirNota(pedido: Pedido, tipoNota) {
    this.carregandoService.mostra('imprimirNota');

    this.notaFiscalService.imprimirNotaPorIdCupom(pedido.idCupom, tipoNota).subscribe(
      (resp) => {
        // this.notificacaoService.sucesso('Documento gerado com sucesso!!!');
        this.utilitarioService.openBlob(resp);

        this.carregandoService.esconde('imprimirNota');
      },
      (erro) => {
        const reader = new FileReader();

        // This fires after the blob has been read/loaded.
        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement['result'];
          this.carregandoService.esconde('imprimirNota');
          this.notificacaoService.erro(text);
        });

        // Start reading the blob as text.
        reader.readAsText(erro.error);
      }
    );
  }

  buscarKitProntoFreteDesconto() {
    this.premissasService.consultarKitProntoFrete().subscribe(
      (f) => {
        this.calcularFrete = f.valor;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );

    this.premissasService.consultarKitProntoDesconto().subscribe(
      (f) => {
        this.calcularDesconto = f.valor;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  async gerarPedido(idCupom, ibge, nomeR, telefoneR, potencia, ufEntrega, nomeVendedor) {
    try {
      this.carregandoService.mostra('buscaPedido');

      const largura = Number($('body').width());

      let formasPagamento = [];

      // const orc = await this.pedidoService.consultarCompleto(idCupom, null, null, false, false).toPromise();

      const buscarItens = () =>
        this.pedidoService
          .bC_Itens(
            idCupom,
            false, // atualizarValores
            true, // buscarEstoque
            false, // buscarFoto
            false // duplicando
          )
          .toPromise();

      const pedidoPromise = this.pedidoService
        .bC_Pedido(
          idCupom,
          false, // atualizarValores
          true, // buscarEstoque
          false // duplicando
        )
        .toPromise();

      const itensPromise = this.pVendaProgramada
        ? // BC_Itens começará somente após BC_Pedido terminar.
          pedidoPromise.then(() => buscarItens())
        : // Fora de venda programada, ambos começam simultaneamente.
          buscarItens();

      const [venda, itens] = await Promise.all([pedidoPromise, itensPromise]);

      // Mantém compatibilidade com o restante do método.
      const orc = {
        venda,
        itens
      };

      this.pedido = orc.venda;

      this.pedido.seguros = await this.buscarSeguros(idCupom);
      // if (this.pedido.formaPag === 0 && this.pedido.planoPag === 0) {
      //   formasPagamento = await this.buscarFormasDePagamentoPorIdCupom(idCupom);
      // }

      let percentualFreteAvulso = undefined;

      if (this.bloquearTipoFreteVendaDireta && this.pedido.origemGI === 2) {
        let totalValorCif = 0;
        let totalValorFob = 0;

        orc.itens.forEach((p) => {
          if (p.qt > 0) {
            totalValorCif += p.precoCif * p.qt;
            totalValorFob += p.pUnitario * p.qt;
          }
        });

        percentualFreteAvulso = totalValorCif === 0 ? 0 : (1 - totalValorFob / totalValorCif) * 100;
      }

      const qtModulos = orc.itens.reduce((total, it) => {
        if (it.produtoTela.familia === 2) {
          return total + it.qt;
        }
        if (it.produtoTela.familia === 7) {
          return (
            total +
            it.produtoTela.composicao.reduce((compTotal, comp) => {
              return comp.produtoMP.familia === 2 ? compTotal + comp.qt * it.qt : compTotal;
            }, 0)
          );
        }
        return total;
      }, 0);

      const data = {
        origem: this.pedido.origemGI,
        tipo: 1,
        valorProdutos: this.pedido.valorTotal,
        ibge: ibge,
        da: this.pedido.da,
        valorDa: this.pedido.da === 0 ? this.pedido.valorDa * -1 : this.pedido.valorDa,
        percentual: this.pedido.percentual,
        tipoFrete: this.pedido.tipoFrete,
        tipoFreteAnterior: this.pedido.tipoFrete,
        tipoLocalizacao: this.pedido.tipoLocalizacao,
        idCliente: this.pedido.cliente,
        taxaDA: this.pedido.taxaDA,
        formasPagamento: this.pedido.formasPagamento,
        idCupom: idCupom,
        nomeResponsavel: nomeR,
        telefoneResponsavel: telefoneR,
        valorServico: this.pedido.valorServico,
        valorLiquido: this.pedido.valorServicoLiquido,
        cupomDesconto: this.pedido.cupomDesconto,
        naoCalcularFrete: !this.calcularFrete && this.pedido.origemGI === 1,
        naoCalcularDesconto: !this.calcularDesconto && this.pedido.origemGI === 1,
        idDescarga: this.pedido.idDescarga,
        valorFrete: this.pedido.frete,
        idCD: this.pCentroDistribuicao || this.pMultiFornecedor ? this.pedido.idFornecedor : undefined,
        vendedor: { idFuncion: this.pedido.vendedor, nome: nomeVendedor },
        gerandoPeloOrcamento: true,
        nome: this.pedido.comprador,
        freteManual: this.pedido.freteManual,
        vendaDireta: this.pedido.vendaDireta,
        idClienteFaturamento: this.pedido.clienteFaturamento,
        potencia: potencia,
        servicoEntrega: this.pedido.servicoEntrega,
        valorServicoEntrega: this.pedido.valorServicoEntrega,
        servicoEntregaManual: this.pedido.servicoEntregaManual,
        seguros: this.pedido.seguros,
        valorProjeto: this.pedido.valorProjeto,
        valorProjetoLiquido: this.pedido.valorProjetoLiquido,
        descontoIndividual: this.pedido.descontoIndividual,
        avulso: this.pedido.origemGI === 2,
        tipoIntegracao: this.pedido.tipoIntegracao,
        bloquearTipoFreteVendaDireta: this.bloquearTipoFreteVendaDireta && this.pedido.origemGI === 2,
        percentualFreteAvulso:
          this.bloquearTipoFreteVendaDireta && this.pedido.origemGI === 2 ? percentualFreteAvulso : undefined,
        valorTotalFixo: this.pedido.valorTotalFixo,
        descAcresPrecificacaoUF: this.premissasSistema.usarPrecificacaoPorUF
          ? this.precificacoesUF.some((p) => p.uf === ufEntrega)
            ? this.precificacoesUF.find((p) => p.uf === ufEntrega)
            : { percentual: 0, uf: '', tipoDa: 0 }
          : undefined,
        itens: JSON.parse(JSON.stringify(orc.itens)),
        idFornecedor: this.pedido.idFornecedor,
        tipoCIF: this.pedido.tipoCIF,
        qtModulos: qtModulos,
        idFrete: this.pedido.idFrete,
        ipi: this.pedido.ipi,
        ibs: this.pedido.ibs,
        cbs: this.pedido.cbs,
        usandoMultiFormasPagamento: this.pedido.multiFormaPagamento,
        impostos: this.pedido.impostos,
        valorImpostos: this.pedido.valorImpostos,
        impostosPendente: this.pedido.impostosPendente,
        cliente: await this.buscarCliente(this.pedido.cliente)
      };

      if (this.pedido.vendedor) {
        this.funcionarioService.consultarLimitDesc(this.pedido.vendedor).subscribe(
          (result) => {
            this.abrirModalDigitaCampo({ ...data, limDesc: result });
          },
          (err) => {
            this.notificacaoService.erro(err);
          }
        );
      } else {
        this.abrirModalDigitaCampo(data);
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscaPedido');
    }
  }

  abrirModalDigitaCampo(data) {
    const dialogRef = this.dialog.open(DigitaCampoModalComponent, {
      width: $('body').width().toString() + 'px',
      panelClass: 'modal-card',
      data,
      // maxHeight: '90vh',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.enderecoDeEntrega = result.enderecoEntrega;

        this.respostas = result.respostas;

        this.pedidoService.setFormaPagPedido(this.pedido, result.formaPagamento);
        this.pedidoService.setCondPagPedido(this.pedido, result.condicaoPagamento);

        this.pedido.formasPagamento = result.formasPagamento;

        this.pedido.vendaDireta = result.vendaDireta;
        this.clienteFaturamento = result.clienteFaturamento;
        this.pedido.da = Number(result.da);
        this.pedido.valorDa = Number(result.valorDa);
        this.pedido.percentual = Number(result.percentual);
        this.pedido.frete = Number(result.valorFrete);
        this.pedido.tipoFrete = Number(result.tipoFrete);
        this.pedido.tipoLocalizacao = Number(result.localizacao);
        this.pedido.taxaDA = Number(result.taxaDA);
        this.pedido.valorServico = Number(result.valorServico);
        this.pedido.valorServicoLiquido = Number(result.valorLiquido);
        this.pedido.transportadora = result.idTransportadora;
        this.pedido.entrega = Number(result.entrega);

        this.pedido.comprador = result.nome;

        this.pedido.freteManual = result.freteManual;

        this.pedido.voucher = result.voucher;
        this.pedido.valorVoucher = result.valorVoucher;
        this.pedido.dadosVoucher = result.dadosVoucher;

        this.pedido.seguros = result.seguros;
        this.pedido.servicoEntrega = result.servicoEntrega;
        this.pedido.valorServicoEntrega = result.valorServicoEntrega;
        this.pedido.servicoEntregaManual = result.servicoEntregaManual;

        this.pedido.valorProjeto = result.valorProjeto;
        this.pedido.valorProjetoLiquido = result.valorProjetoLiquido;

        this.pedido.valorTotalFixo = result.valorTotalFixo;

        this.pedido.obs2 = result.enderecoEntregaCompleto;

        if (this.pedido.valorDa < 0) {
          this.pedido.valorDa = this.pedido.valorDa * -1;
        }

        this.pedido.idDescarga =
          result.idDescarga === null || result.idDescarga === undefined ? null : Number(result.idDescarga);

        this.comprovante = result.comprovante;
        this.confirmar = result.confirmar;

        this.itens = JSON.parse(JSON.stringify(result.itens));
        this.pedido.valorTotal = result.valorProdutos;

        this.pedido.cupomDesconto = result.cupomDesconto;

        this.pedido.tipoCIF = result.tipoCIF;

        this.pedido.idFrete = result.idFrete;

        this.pedido.ipi = result.ipi;
        this.pedido.ibs = result.ibs;
        this.pedido.cbs = result.cbs;

        this.pedido.multiFormaPagamento = result.usandoMultiFormasPagamento;

        this.pedido.impostos = result.impostos;
        this.pedido.valorImpostos = result.valorImpostos;
        this.pedido.impostosPendente = result.impostoPendente;

        this.salvarPedido();
      }
    });
  }

  salvarPedido() {
    this.carregandoService.mostra('salvaPedido');

    if ((this.tipo === 0 || this.pedido.ordemEtapa === 38) && this.confirmar) {
      this.pedidoService
        .confirmarOrcamento(
          this.pedido,
          this.itens,
          [],
          this.pedido.vendaDireta ? this.clienteFaturamento : null,
          false,
          this.tipo === 0,
          true,
          this.enderecoDeEntrega,
          this.comprovante,
          this.respostas
        )
        .subscribe(
          (resp: any) => {
            this.carregandoService.esconde('salvaPedido');
            //
            this.notificacaoService.sucesso('Pedido Confirmado com sucesso!!!');
            if (this.tipo === 0) {
              this.router.navigate(['/pedidos']);
            } else {
              this.buscarPedidos();
            }
          },
          (erro) => {
            this.carregandoService.esconde('salvaPedido');
            this.notificacaoService.erro(erro);
          }
        );
    } else {
      this.pedidoService
        .salvar(
          this.pedido,
          this.itens,
          [],
          this.pedido.vendaDireta ? this.clienteFaturamento : null,
          false,
          this.tipo === 0,
          true,
          this.enderecoDeEntrega,
          this.respostas
        )
        .subscribe(
          (resp: any) => {
            this.notificacaoService.sucesso('Pedido salvo com sucesso!!!');
            this.router.navigate(['/pedidos']).then((p) => {
              this.carregandoService.esconde('salvaPedido');
            });
          },
          (erro) => {
            this.carregandoService.esconde('salvaPedido');
            this.notificacaoService.erro(erro);
          }
        );
    }
  }

  exibirObservacoes(pedido: Pedido) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(ObservacoesModalComponent, {
      width: largura > 1050 ? '1000px' : $('body').width().toString() + 'px',
      data: { idCupom: pedido.idCupom, pedido: pedido },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.buscarPedidos();
    });
  }

  restaurarFiltros() {
    this.filtroPedido = {
      dtFim: undefined,
      dtInicio: undefined,
      funcionario: this.administrador ? 0 : !this.integrador ? -1 : undefined,
      idCupom: '',
      nomeCliente: '',
      status: undefined,
      etapas: [],
      integrador: undefined,
      orcStatus: undefined,
      idUsuarioIntegrador: undefined,
      referencia: undefined,
      idFornecedor: undefined,
      codErp: '',
      pesquisaPorTimes: false
    };
    this.paginator.firstPage();
    this.paginacao.paginaAtual = 1;
    this.paginacao.total = 0;

    this.buscarPedidos();
    this.buscarTotal();
  }

  imprimirPedido(idPedido) {
    this.carregandoService.mostra('imprimirPedido');

    this.relatorioService.pedido(idPedido).subscribe(
      (resp) => {
        this.notificacaoService.sucesso('Documento gerado com sucesso!!!');
        // this.utilitarioService.saveBlob(resp, idPedido + ".pdf");
        this.utilitarioService.openBlobModal(resp, idPedido);

        this.carregandoService.esconde('imprimirPedido');
      },
      (erro) => {
        const reader = new FileReader();

        // This fires after the blob has been read/loaded.
        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement['result'];
          this.carregandoService.esconde('imprimirPedido');
          this.notificacaoService.erro(text);
        });

        // Start reading the blob as text.
        reader.readAsText(erro.error);
      }
    );
  }

  anexos(pedido: Pedido) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(PedidoAnexoComponent, {
      width: this.integrador && largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {
        idPedido: pedido.idCupom,
        podeEditar: true
      },
      panelClass: 'modal-card'
    });
    dialogRef.afterClosed().subscribe(() => {
      this.buscarPedidos();
    });
  }

  notasFiscais(pedido: Pedido) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(NotaFiscalPedidoModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {
        idCupom: pedido.idCupom
      },
      panelClass: 'modal-card'
    });
  }

  alterarStatusOrcamento(pedido: PedidoLista) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(SelecionarStatusOrcamentoModalComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: {
        idCupom: pedido.idCupom,
        idStatus: pedido.orcStatus
      },
      panelClass: 'modal-card'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarPedidos();
      }
    });
  }

  alterarEtapaPedido(pedido: PedidoLista) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(SelecionarEtapaPedidoModalComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: {
        idCupom: pedido.idCupom,
        idEtapa: pedido.idEtapa
      },
      panelClass: 'modal-card'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarPedidos();
      }
    });
  }

  alterarAnotacaoStatusOrcamento(pedido: PedidoLista) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(AnotacaoStatusModalComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: {
        idCupom: pedido.idCupom,
        anotacao: pedido.anotacaoStatus
      },
      panelClass: 'modal-card'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        pedido.anotacaoStatus = result.anotacao;
      }
    });
  }

  alterarCupomDesconto(pedido: PedidoLista) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(CupomDescontoModalComponent, {
      width: largura > 730 ? '700px' : $('body').width().toString() + 'px',
      data: {
        idCupom: pedido.idCupom
      },
      panelClass: 'modal-card'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarPedidos();
      }
    });
  }

  buscarKitProntoDesconto() {
    this.premissasService.consultarKitProntoDesconto().subscribe(
      (f) => {
        this.pKitProntoDesconto = f.valor;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarIntegradorAnexar() {
    this.premissasService.consultarIntegradorAnexar().subscribe(
      (f) => {
        this.integradorPodeAnexar = f.valor;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarBloqClonar() {
    this.premissasService.consultarBloqClonar().subscribe(
      (f) => {
        this.bloqClonar = f.valor;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  geraPagamentoOctopus(pedido: PedidoLista) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(PagamentoOctopusComponent, {
      width: largura > 730 ? '800px' : $('body').width().toString() + 'px',
      data: {
        pedido: pedido
      },
      panelClass: 'modal-card'
    });
  }

  podeGerarRecebimento(pedido: PedidoLista, tipo: string): boolean {
    if (this.tipo === 0) {
      return false;
    }

    if (pedido.status === StatusDoPedido.Cancelado || pedido.status === StatusDoPedido.Expirado) {
      return false;
    }

    switch (tipo) {
      case 'Octopus':
        return (
          this.hopperOctopusGiService.isConfigured() &&
          pedido.formasPagamento !== null &&
          pedido.formasPagamento !== undefined &&
          pedido.formasPagamento.length > 0 &&
          this.formasDePagamentosOctopus.some((forma) =>
            pedido.formasPagamento.some((f) => f.idFormaPag === forma.id)
          ) &&
          this.premissasSistema.ordemEtapasGeracaoRecebimento.includes(pedido.ordemEtapa)
        );
      case 'FotusBoleto':
        return (
          (pedido.formaBoleto || (pedido.formaBoleto && this.boletoFotus)) &&
          this.premissasSistema.ordemEtapasGeracaoRecebimento.includes(pedido.ordemEtapa)
        );
      case 'MercadoPago':
        return (
          pedido.formasPagamento !== null &&
          pedido.formasPagamento !== undefined &&
          pedido.formasPagamento.length > 0 &&
          this.formasDePagamentosMercadoPago.some((forma) =>
            pedido.formasPagamento.some((f) => f.idFormaPag === forma.id)
          ) &&
          this.premissasSistema.ordemEtapasGeracaoRecebimento.includes(pedido.ordemEtapa)
        );
      default:
        return false;
    }
  }

  async buscarSeguros(idCupom) {
    try {
      this.carregandoService.mostra('buscarSeguros');
      return await this.pedidoService.consultarSeguros(idCupom).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarSeguros');
    }
  }

  async buscarFormasDePagamentoPorIdCupom(idCupom) {
    try {
      this.carregandoService.mostra('buscarFormasDePagamento');
      return await this.pedidoService.consultarFormasDePagamento(idCupom).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarFormasDePagamento');
    }
  }

  async buscarBloquearTipoFreteVendaDireta() {
    try {
      this.carregandoService.mostra('buscarBloquearTipoFreteVendaDireta');
      this.bloquearTipoFreteVendaDireta =
        (await this.premissasService.consultarCodEverest().toPromise()).valor === '919';
      this.carregandoService.esconde('buscarBloquearTipoFreteVendaDireta');
    } catch (erro) {
      this.carregandoService.esconde('buscarBloquearTipoFreteVendaDireta');
      this.notificacaoService.erro(erro);
    }
  }

  async reativarOrcPedExpirado(idCupom) {
    swal({
      title: 'ATENÇÃO!',
      text: 'Deseja realmente atualizar o ' + (this.tipo === 0 ? 'orçamento' : 'pedido') + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then(async (result) => {
      if (result.value) {
        try {
          this.carregandoService.mostra('reativarOrcPedExpirado');
          await this.pedidoService.reativarOrcPedExpirado(idCupom).toPromise();
          this.carregandoService.esconde('reativarOrcPedExpirado');
          this.notificacaoService.sucesso((this.tipo === 0 ? 'Orçamento' : 'Pedido') + ' atualizado com sucesso!!!');
          this.buscarPedidos();
        } catch (erro) {
          this.carregandoService.esconde('reativarOrcPedExpirado');
          this.notificacaoService.erro(erro);
        }
      }
    });
  }

  abrirModalTransferenciaVendedor(pedido) {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(TransferenciaItemsVendedorModalComponent, {
      width: largura > 830 ? '800px' : $('body').width().toString() + 'px',
      data: {
        somentePedido: this.tipo === 1,
        somenteOrcamento: this.tipo === 0,
        idCupom: pedido.idCupom,
        funcionarioDe: pedido.idVendedor
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarPedidos();
      }
    });
  }

  async abrirModalMercadoPago(idCupom: string) {
    try {
      this.carregandoService.mostra('criarReferenciaMercadoPago');
      const idMP = (await this.pedidoService.criarReferenciaMercadoPago(idCupom).toPromise()).idMP;

      if (idMP) {
        this.utilitarioService.modalMercadoPago(idMP, 'pedidos-main-content');
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('criarReferenciaMercadoPago');
    }
  }

  buscarPrecificacoesUF() {
    this.carregandoService.mostra('buscarPrecificacoesUF');

    this.precificacaoUFService.consultar().subscribe(
      (precificacoesUF) => {
        this.precificacoesUF = precificacoesUF;
        this.carregandoService.esconde('buscarPrecificacoesUF');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPrecificacoesUF');
        this.notificacaoService.erro(erro);
      }
    );
  }

  abrirAnaliseDeDesconto(pedido: PedidoLista) {
    const dialogRef = this.dialog.open(AnaliseDescontoSolicitacaoModalComponent, {
      width: '1078px',
      data: {
        idCupom: pedido.idCupom
      },
      panelClass: ['modal-card', 'modal-card-v2']
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        pedido.possuiAnaliseDesconto = true;
      }
    });
  }

  retornaCorAnaliseDesconto(status: AnaliseDescontoStatus) {
    if (status === undefined || status === null) {
      return 'btn-dark';
    }

    switch (status) {
      case AnaliseDescontoStatus.DescontoConcedido:
        return 'btn-success';

      case AnaliseDescontoStatus.DescontoNaoConcedido:
        return 'btn-danger';

      default:
        return 'btn-primary';
    }
  }

  async buscarFinanciamentoConfig() {
    try {
      this.carregandoService.mostra('buscarFinanciamentoConfig');
      this.financiamentoConfig = (await this.financiamentoService.buscar().toPromise()).result;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarFinanciamentoConfig');
    }
  }

  async verificarSeIntegradorPodeSimular(idIntegrador) {
    try {
      this.carregandoService.mostra('verificarSeIntegradorPodeSimular');

      // Integrador bloqueado para financiamento: a API de financiamento responde 403, o que derrubaria a sessão.
      const integrador = await this.clienteService.consultarPorIdClienteSimples(idIntegrador).toPromise();

      if (integrador && integrador.podeVerFinanciamento === false) {
        return false;
      }

      const queryFilter = this.queryFilterService.getQueryBuilder();
      this.queryFilterService.applyFilters(queryFilter, this.definirFiltros());

      return (
        (await this.finSimulacaoService.listarFinanciadorasIntegradorV2(idIntegrador, queryFilter.build()).toPromise())
          .results.length > 0
      );
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('verificarSeIntegradorPodeSimular');
    }
  }

  definirFiltros(): GridfyFilter[] {
    let filtros: GridfyFilter[] = [];

    filtros.push({ field: 'situacao', operator: '=', value: true.toString() });

    return filtros;
  }

  async fazerSimulacaoFinanciamento(pedido: PedidoLista) {
    const simulacao = await this.buscarSimulacaoPedido(pedido.idCupom);

    if (pedido.possuiFinSimulacao && simulacao) {
      this.router.navigate(['financiamento/edit-simulacao', simulacao.id]);
      return;
    }

    const cliente = await this.buscarCliente(pedido.idCliente);
    let clienteFaturamento = null;

    clienteFaturamento = await this.buscarClienteFaturamento(pedido.idCupom);

    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(NovaSimulacaoModalComponent, {
      width: largura > 1000 ? '80%' : $('body').width().toString() + 'px',
      data: {
        cliente: cliente,
        temDadosPessoais: clienteFaturamento != null && clienteFaturamento != undefined,
        dadosPessoais: clienteFaturamento,
        potencia: pedido.potencia,
        pedido: pedido
      },
      panelClass: 'modal-card',
      maxHeight: '100vh'
    });

    dialogRef.afterClosed().subscribe((result: GiFinSimulacaoModel) => {
      if (result) {
        this.router.navigate(['financiamento/edit-simulacao', result.id]);
      }
    });
  }

  async buscarSimulacaoPedido(idCupom: string): Promise<GiFinSimulacaoModel | null> {
    this.carregandoService.mostra('buscarSimulacaoPedido');

    try {
      this.carregandoService.esconde('buscarSimulacaoPedido');
      return (await this.simulacaoService.buscarSimulacaoPedido(idCupom).toPromise()).result;
    } catch (erro) {
      this.carregandoService.esconde('buscarSimulacaoPedido');
      return null;
    }
  }

  async buscarClienteFaturamento(idCupom: string) {
    try {
      this.carregandoService.mostra('buscarClienteFaturamento');
      return await this.pedidoService.consultarClienteVendaDireta(idCupom).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
      return null;
    } finally {
      this.carregandoService.esconde('buscarClienteFaturamento');
    }
  }
}
